module.exports = __webpack_public_path__ + "img/warning.5f862774.svg";